import store from "../redux";
import { getAppProps } from "../redux/appPropsReducer/selectors";

abstract class AppPropsService {
  public static getReCaptchaSiteKey = () =>
    AppPropsService.getAppProps().reCaptchaSiteKey;

  public static getVoiceGainApplicationApiUrlPath = () =>
    AppPropsService.getAppProps().voiceGainApplicationApiUrlPath;

  public static getVoiceGainAuthSvcApiUrlPath = () =>
    AppPropsService.getAppProps().voiceGainAuthSvcApiUrlPath;

  public static getVoiceGainServerUrl = () =>
    AppPropsService.getAppProps().voiceGainServerUrl;

  public static getSsoClientUrl = () =>
    AppPropsService.getAppProps().ssoClientUrl;

  private static getAppProps = () => getAppProps(store.getState());
}

export default AppPropsService;
